import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { PICFLOW_CONFIG } from '../../../picflow-config';

@Component({
  selector: 'app-svg',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  host: {
    '[style.mask-image]': 'maskImage()',
  },
})
export class SvgComponent {
  private config = inject(PICFLOW_CONFIG);
  src = input.required<string>();

  readonly maskImage = computed(() => {
    if (this.config.useAbsoluteUrls) {
      return `url(${this.config.correctPicflowUrl + this.src()})`;
    }
    return `url(${this.src()})`;
  });
}
